export default {
	"862933ac7f360b6b2fd4b24213480431": "Please select the available coupons",
	"ac52b8119d35b04fdd6793a65b929fcc": "No available offer",
	"8f51667edd111b7a03b1108733d4a340": "No available vouchers",
	"3fd254568652167791795ad640c7a28a": "Please select the available vouchers",
	"a893fa4579f7a97990a3c599dded4e92": "Commodity price",
	"1d59b98806a14ed49870ebe5d49ea5a7": "Discount amount",
	"db261923bd8f684a1e5aabf371e19c5e": "Coupon",
	"2214d3c5f836c44fbae49da0e0f5dbbf": "Voucher",
	"e05bcef28c7bbeb6454df0dd89544a19": "Discounted",
	"8a50c5528c9de6ca7c9d381f766cea6b": "Total"
}
